'use client';

export { default } from './ListItemText';
export { default as listItemTextClasses } from './listItemTextClasses';
export * from './listItemTextClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ListItemText/index.js
// module id = 487
// module chunks = 22